import UmlDiagramItem from './UmlDiagramItem';

// Alles met een zichtbare box: +w, +h, +zIndex bovenop UmlDiagramItem.
class UmlShape extends UmlDiagramItem {
  constructor(id, x, y, w, h, zIndex) {
    super(id, x, y);
    this.w = w;
    this.h = h;
    this.zIndex = zIndex || 0;
    this.parentId = null;
    // Persisted, not widget-state — geometry code (ShapeGeoBuilder.effectiveHeight)
    // and rendering need to know collapse-state. Shapes without a visual collapse
    // concept just never toggle it, harmless default false.
    this.collapsed = false;
  }

  setCollapsed(collapsed) {
    this.collapsed = collapsed;
  }

  resizeTo(w, h) {
    this.w = w;
    this.h = h;
  }

  bringToFront(nextZIndex) {
    this.zIndex = nextZIndex;
  }

  containsPoint(px, py) {
    return px >= this.x && px <= this.x + this.w && py >= this.y && py <= this.y + this.h;
  }
}

export default UmlShape;
